import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useHistory } from "react-router-dom";
// import { Divider } from 'primereact/divider'; // Removed Divider import
import { Fieldset } from 'primereact/fieldset';
import { Menubar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
// import { Divider } from 'primereact/divider'; // Removed Divider import
import { Chip } from 'primereact/chip'; // Import Chip component
import { Tooltip } from 'primereact/tooltip'; // Import Tooltip component

// Import the new components
import PricingCard from './components/PricingCard';
import TestimonialCard from './components/TestimonialCard';
import HowItWorksStep from './components/HowItWorksStep';
import LinkButton from '../../constants/helpers/LinkButton';

// Define an interface for the features structure
// Updated interface to expect an array of string tuples with an optional third element for tooltip
interface PlanFeatures {
  [category: string]: Array<[string, string | undefined, string | undefined]>;
}

interface HomeProps {
}

const Home = (homeProps: HomeProps) => {
  const { } = homeProps;
  const history = useHistory();

  // Use the defined interface for the parameter type
  const renderFeatures = (features: PlanFeatures) => {
    return (
      <ul className="list-none p-0 m-0">
        {Object.keys(features).map((category, index) => (
          <li key={index} className="mb-3">
            <strong className="text-primary">{category}</strong>
            <ul className="list-none p-0 m-0 my-1">
              {/* Updated map to handle the new structure [mainText, chipLabel, tooltipContent] */}
              {features[category].map((featureTuple, subIndex: number) => {
                const [mainText, chipLabel, tooltipContent] = featureTuple;

                return (
                  <li key={subIndex} className="text-color-secondary flex align-items-center h-2rem overflow-hidden">
                    <i className="pi pi-check-circle mr-2 text-sm text-green-500"></i>
                    <span>{mainText}</span> {/* Display the main text */}
                    {chipLabel && ( // Check if chipLabel exists before rendering Chip
                      // Add data-pr-tooltip for the tooltip
                      <Chip
                        label={chipLabel}
                        className="ml-2 text-xs"
                        data-pr-tooltip={tooltipContent} // Use the third element for tooltip
                        data-pr-position="top" // Position the tooltip
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    );
  };

  const mailToLink = "mailto:interest@x-interviewer.com?subject=Interest in X-Interviewer&body=I would like to register my interest in X-Interviewer. Please provide me with more information.";
  const mailToButton = ( 
    <a href={mailToLink} className="p-button p-component no-underline p-button-outlined p-button-lg text-white border-white">
      <span className="p-button-label p-c">Register Your Interest</span>
      <span className="p-button-icon p-c p-button-icon-right pi pi-heart-fill"></span>
    </a>
  );

  // Updated data structure for features with manually capitalized words and separate tooltip text
  const planAFeatures: PlanFeatures = {
    "Job Management": [
      ["Create/Update Job Listing", undefined, undefined],
      ["Landing Page With Job Listing", undefined, undefined]
    ],
    "Resume Management": [
      ["AI Resume Extraction", "100 Resumes", "resumes per month"],
      ["Upload And Track Resumes", undefined, undefined],
      ["Resume Versioning", undefined, undefined]
    ],
    "Interview Management": [
      ["AI Interview Bot", "100 Sessions", "sessions per month"],
      ["Interview Flow Configuration", undefined, undefined],
      ["Interview Bot Configuration", undefined, undefined],
      ["Track And Manage Interview Sessions", undefined, undefined]
    ]
  };

  // Updated data structure for features with manually capitalized words and separate tooltip text
  const planBFeatures: PlanFeatures = {
    "Everything from Plan A": [["Everything From Plan A", undefined, undefined]], // Keep this as a single item if needed
    "Job Management": [
      ["AI Job Matching", "50 New Matchings", "New Matchings per Month"]
    ],
    "Resume Management": [
      ["AI Resume Extraction", "500 Resumes", "Resumes per Month"]
    ],
    "Interview Management": [
      ["AI Interview Bot", "500 Sessions", "Sessions per Month"],
      ["AI Interview Scoring", undefined, undefined],
      ["AI Interview Flow Generation", undefined, undefined]
    ],
    "Report Management": [
      ["Multiple Report Formats", undefined, undefined],
      ["Download Reports as Excel", undefined, undefined]
    ]
  };

  // Updated data structure for features with manually capitalized words and separate tooltip text
  const planCFeatures: PlanFeatures = {
    "Everything from Plan B": [["Everything From Plan B", undefined, undefined]], // Keep this as a single item if needed
    "Job Management": [
      ["AI Job Matching", "200 New Matchings", "New Matchings per Month"]
    ],
    "Resume Management": [
      ["AI Resume Extraction", "1000 Resumes", "Resumes per Month"]
    ],
    "Interview Management": [
      ["AI Interview Bot", "1000 Sessions", "Sessions per Month"]
    ],
    "Additional Integrations": [
      ["Retrieve Jobs From MyCareersFuture", undefined, undefined]
    ]
  };


  const adminUrl = process.env.REACT_APP_ADMIN_URL || '#';

  const items: MenuItem[] = [
      {
          label: 'Product',
          url: '#product-highlight-section',
          className: 'mr-3'
      },
      {
          label: 'Features',
          url: '#features-overview-section',
          className: 'mr-3'
      },
      {
          label: 'Pricing',
          url: '#pricing-section',
          className: 'mr-3'
      },
      {
          label: 'Testimonials',
          url: '#testimonial-section',
          className: 'mr-3'
      },
      {
          label: 'How it Works',
          url: '#how-it-works-section'
      }
  ];

  const start = (
      <div className="flex align-items-center mr-5">
          <img src="/logo.png" alt="X-Interviewer Logo" style={{ height: '40px' }} className="mr-3" />
          <h3 className="m-0">X-Interviewer</h3>
      </div>
  );

  const end = (
    // Use history.push for navigation
    <a href={adminUrl} target="_blank" className="p-button p-component no-underline p-button-primary">
      <span className="p-button-icon p-c p-button-icon-left pi pi-user"></span>
      <span className="p-button-label p-c">Dashboard</span>
    </a>
  );


  return (
    <div className="flex flex-column nogutter homepage-container surface-ground">
      {/* Tooltip component to enable tooltips */}
      <Tooltip target=".p-chip[data-pr-tooltip]" />

      <header className="homepage-header surface-card shadow-2">
         <Menubar model={items} start={start} end={end} className="p-4 border-none" />
      </header>

      <section className="relative overflow-hidden bg-blue-600 text-white py-8 px-4 md:px-6 animate__animated animate__fadeIn">
          <div className="col-12 md:col-8 mx-auto text-center">
              <h1 className="text-4xl md:text-6xl font-bold mb-3"><i className="pi pi-sparkles mr-3"></i>Revolutionize Your Hiring with AI</h1>
              <p className="text-xl mb-5">
                  X-Interviewer is the leading AI-powered platform designed to streamline your recruitment process,
                  saving you time and helping you find the perfect candidates faster.
              </p>
              <Button label="View Demo" icon="pi pi-arrow-right" iconPos="right" className="p-button-secondary p-button-lg mr-3" />
              {mailToButton}
          </div>
      </section>

      <section id="product-highlight-section" className="py-6 px-4 md:px-6 text-center product-highlight-section animate__animated animate__fadeInUp surface-section">
        <div className="col-12 md:col-8 mx-auto">
          <h2 className="text-900 mb-4"><i className="pi pi-question-circle mr-3 text-primary"></i>Why Choose X-Interviewer?</h2>
          <p className="text-lg mb-4 text-700">
            Our platform goes beyond traditional hiring tools, offering intelligent automation and deep insights
            powered by advanced AI. From initial screening to final interviews, X-Interviewer provides the tools
            you need to make informed decisions and build your ideal team.
          </p>
        </div>
      </section>

      <section id="features-overview-section" className="py-6 px-4 md:px-6 text-center animate__animated animate__fadeInUp animate__delay-1s surface-ground">
          <div className="col-12 md:col-10 mx-auto">
              <h2 className="text-900 mb-5"><i className="pi pi-list mr-3 text-primary"></i>Key Features</h2>
              <div className="grid">
                  <div className="col-12 md:col-4 mb-4">
                      <Card title="AI Resume Screening" className="h-100 surface-card shadow-2">
                          <i className="pi pi-file text-primary text-4xl mb-3"></i>
                          <p className="text-700">Quickly analyze and extract key information from resumes using AI.</p>
                      </Card>
                  </div>
                  <div className="col-12 md:col-4 mb-4">
                       <Card title="AI Interview Bot" className="h-100 surface-card shadow-2">
                           <i className="pi pi-android text-primary text-4xl mb-3"></i>
                          <p className="text-700">Conduct automated interviews with a configurable AI bot.</p>
                      </Card>
                  </div>
                   <div className="col-12 md:col-4 mb-4">
                       <Card title="AI Interview Scoring" className="h-100 surface-card shadow-2">
                           <i className="pi pi-star text-primary text-4xl mb-3"></i>
                          <p className="text-700">Get objective scoring and insights from AI-powered interview analysis.</p>
                      </Card>
                  </div>
              </div>
          </div>
      </section>

      <section id="pricing-section" className="py-6 px-4 md:px-6 text-center pricing-section animate__animated animate__fadeInUp animate__delay-1s surface-section">
        <h2 className="text-900"><i className="pi pi-dollar mr-3 text-primary"></i>Simple & Transparent Pricing</h2>
        <div className="grid justify-content-center mt-5">

          {/* Use the PricingCard component */}
          <PricingCard
            title="X-1"
            description="Essential tools for efficient hiring."
            price="S$5"
            priceFrequency="/month"
            yearlyPrice="or S$50/year"
            features={planAFeatures}
            buttonLabel="Choose X-1"
            renderFeatures={renderFeatures} // Pass the renderFeatures function
          />

          {/* Use the PricingCard component for the popular plan */}
          <PricingCard
            title="X-2"
            description="Scale up your AI-powered recruitment."
            price="S$10"
            priceFrequency="/month"
            yearlyPrice="or S$100/year"
            features={planBFeatures}
            buttonLabel="Choose X-2"
            buttonClass="p-button-primary"
            highlight={true}
            renderFeatures={renderFeatures} // Pass the renderFeatures function
          />

          {/* Use the PricingCard component */}
          <PricingCard
            title="X-3"
            description="Comprehensive features for large-scale hiring."
            price="S$15"
            priceFrequency="/month"
            yearlyPrice="or S$150/year"
            features={planCFeatures}
            buttonLabel="Choose X-3"
            renderFeatures={renderFeatures} // Pass the renderFeatures function
          />

        </div>
      </section>

      <section id="testimonial-section" className="py-6 px-4 md:px-6 text-center testimonial-section animate__animated animate__fadeInUp animate__delay-2s surface-ground">
        <h2 className="text-900"><i className="pi pi-comment mr-3 text-primary"></i>What Our Customers Say</h2>
        <div className="grid justify-content-center mt-5">

          {/* Use the TestimonialCard component */}
          <TestimonialCard
            quote="X-Interviewer has transformed our hiring process. The AI features save us countless hours!"
            author="Satisfied Customer A"
          />
          <TestimonialCard
            quote="The AI interview bot is a game-changer. It's efficient and provides valuable insights."
            author="Happy User B"
          />
          <TestimonialCard
            quote="Pricing is fair and the features are exactly what we needed to scale our recruitment."
            author="Delighted Client C"
          />

        </div>
      </section>

      <section id="how-it-works-section" className="py-6 px-4 md:px-6 text-center animate__animated animate__fadeInUp animate__delay-3s surface-section">
          <div className="col-12 md:col-10 mx-auto">
              <h2 className="text-900 mb-5"><i className="pi pi-cog mr-3 text-primary"></i>How It Works</h2>
              <div className="grid">

                  {/* Use the HowItWorksStep component */}
                  <HowItWorksStep
                    legend="Step 1: Setup"
                    iconClass="pi pi-wrench"
                    description="Create your job listing and configure your interview flow."
                  />
                  <HowItWorksStep
                    legend="Step 2: Screen"
                    iconClass="pi pi-search"
                    description="Use AI to extract resume data and identify top candidates."
                  />
                  <HowItWorksStep
                    legend="Step 3: Interview"
                    iconClass="pi pi-comments"
                    description="Let the AI bot conduct initial interviews and provide scoring."
                  />

              </div>
          </div>
      </section>

       <section id="call-to-action-section" className="py-6 px-4 md:px-6 text-center bg-primary text-white animate__animated animate__fadeInUp animate__delay-4s">
           <div className="col-12 md:col-8 mx-auto">
               <h2 className="text-white mb-3"><i className="pi pi-bullhorn mr-3"></i>Ready to Transform Your Hiring?</h2>
               <p className="text-lg mb-5">Join thousands of companies streamlining their recruitment with X-Interviewer.</p>
               {mailToButton}
           </div>
       </section>

      <footer className="py-4 px-4 md:px-6 text-center surface-section text-color-secondary">
        <div className="flex flex-row align-items-center justify-content-center">
          <p className="m-0 text-sm">A product of</p>
          <a href="https://www.maventree.com" target="_blank" rel="noopener noreferrer" className="ml-2">
            <img src="https://www.maventree.com/wp-content/uploads/2022/12/200xlogo.png" alt="MavenTree" style={{ height: '20px' }} />
          </a>
        </div>
      </footer>

    </div>
  );
}

export default Home;